import { first } from 'lodash';

import { isAnyDistanceCumulative, isAnyDistanceVirtual } from '../derivations';
import { getRaceId } from './getRaceId';
import { distanceSelect } from './selectOptions';

function getDefaultDistanceId(): null | number {
  const raceId = getRaceId();
  const distancesOptions = distanceSelect.options.get();
  const isSingleDistance = distancesOptions.length === 1;
  const isAbuHardcodeEnabled = raceId === 5153; // Abu hardcode

  if (isAbuHardcodeEnabled || isSingleDistance || isAnyDistanceCumulative.get() || isAnyDistanceVirtual.get()) {
    return first(distancesOptions)?.value || null;
  }

  return null;
}

export { getDefaultDistanceId };
